"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.cognitoIdentityTransferHandler = void 0;
var cognitoIdentityTransferHandler_1 = require("./cognitoIdentityTransferHandler");
Object.defineProperty(exports, "cognitoIdentityTransferHandler", { enumerable: true, get: function () { return cognitoIdentityTransferHandler_1.cognitoIdentityTransferHandler; } });
